import { useNavigate } from 'react-router-dom';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { BackButton } from '@/components/ui/back-button';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

function OrganizationSelectionContent() {
    const navigate = useNavigate();

    return (
        <div>
            <BackButton href="/profile" tooltip="Back to Profile" />
            <div className="flex items-center gap-4 mb-8">
                <h1 className="text-3xl font-bold">Organization Settings</h1>
            </div>

            <Card className="max-w-3xl">
                <CardHeader>
                    <CardTitle>Manage Organizations on the Profile Page</CardTitle>
                    <CardDescription>
                        Active and default organization settings now live directly on the Profile &
                        Settings page.
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                    <p className="text-sm text-muted-foreground">
                        Use the “Active Role in this Session” and “Default Role (Persistent)” cards
                        on your profile to change these preferences. They allow you to switch your
                        current session&apos;s organization context and choose which organization
                        should load automatically on login.
                    </p>
                    <Button onClick={() => navigate('/profile')}>Go to Profile</Button>
                </CardContent>
            </Card>
        </div>
    );
}

export default function OrganizationSelectionPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <OrganizationSelectionContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
